import { Program } from '@/new-transport/_models/transport-map.model';

export enum ParticipantsTabAction {
	TAKE = 'take',
	LEAVE = 'leave',
}

export enum NodeType {
	PROGRAM = 'P',
	RESERVATION = 'R',
	SLOT = 'S',
}

export interface Node {
	name: string;
	children?: Node[];
	id: number;
	type: NodeType;
}

export interface Programs {
	taken: Program[];
	outsideVehicle: Program[];
}
